// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2025/8/18
// +-------------------------------------------------------------
// |Time: 11:37
// +-------------------------------------------------------------
export default [
    //个人中心
    {
        path: '/personal/person',
        name: 'UserPerson',
        component: () => import('@/views/personal/Center/Person'),
    },
    //订单记录
    {
        path: '/personal/spendList',
        name: 'SpendList',
        component: () => import('@/views/personal/Center/SpendList'),
    },
    //小号管理
    {
        path: '/personal/subList',
        name: 'PersonalSubList',
        component: () => import('@/views/personal/Center/SubList'),
    },
    //修改密码
    {
        path: '/personal/password',
        name: 'PersonalPassword',
        component: () => import('@/views/personal/Center/Password'),
    },
    //换绑/绑定手机
    {
        path: '/personal/bind-phone',
        name: 'BindPhone',
        component: () => import('@/views/personal/Center/BindPhone'),
    },
    {
        path: '/personal/unbinding-phone',
        name: 'UnbindingPhone',
        component: () => import('@/views/personal/Center/UnbindingPhone'),
    },
    //显示绑定手机
    {
        path: '/personal/bound-phone',
        name: 'BoundPhone',
        component: () => import('@/views/personal/Center/BoundPhone'),
    },
    //实名认证
    {
        path: '/personal/auth',
        name: 'PersonalAuth',
        component: () => import('@/views/personal/Center/Auth'),
    },
    //钱包
    {
        path: '/personal/wallet',
        name: 'UserWallet',
        component: () => import('@/views/personal/Wallet/UserWallet.vue'),
    },
    //礼包
    {
        path: '/personal/gift',
        name: 'GiftCenter',
        component: () => import('@/views/personal/Gift/Index.vue'),
    },
    {
        path: "/personal/free-gift-detail/:gift_id",
        name: "FreeGiftDetail",
        component: () => import("@/views/personal/Gift/FreeGift/Detail.vue")
    },
    {
        path: "/personal/recharge-gift-detail/:gift_id",
        name: "RechargeGiftDetail",
        component: () => import("@/views/personal/Gift/RechargeGift/Detail.vue")
    },
    //卡券
    {
        path: '/personal/voucher-card',
        name: 'VoucherCard',
        component: () => import('@/views/personal/Card/VoucherCard'),
    },
    //开服表
    {
        path: '/personal/server-list',
        name: 'ServerList',
        component: () => import('@/views/personal/ServerList'),
    },
    //活动列表
    {
        path: '/personal/activity',
        name: 'ActivityList',
        component: () => import('@/views/personal/Activity/ActivityList'),
    },
    //活动详情
    {
        path: '/personal/activity-detail/:activity_id',
        name: 'ActivityDetail',
        component: () => import('@/views/personal/Activity/ActivityDetail'),
    },
    //申请返利
    {
        path: '/personal/activity-rebate/:activity_id/:game_name/:ids?',
        name: 'ActivityRebateOperate',
        component: () => import('@/views/personal/Activity/RebateOperate'),
    },
    {
        path: '/personal/activity-rebate-detail/:ids',
        name: 'ActivityRebateDetail',
        component: () => import('@/views/personal/Activity/RebateDetail'),
    },
    {
        path: '/personal/activity-rebate-list',
        name: 'ActivityRebateList',
        component: () => import('@/views/personal/Activity/RebateList'),
    },
    {
        path: '/personal/redeem-code-order',
        name: 'RedeemCodeOrder',
        component: () => import('@/views/personal/RedeemCode/OrderList.vue'),
    }
]